import { Settings24Regular } from "@fluentui/react-icons";
import { PrimaryButton } from "@fluentui/react";
import { CSSProperties } from "react";

import styles from "./SettingsButton.module.css";

interface Props {
    className?: string;
    onClick: () => void;
    buttonStyle?: CSSProperties;
    containerStyle?: CSSProperties;
    iconClassName?: string;
}

export const SettingsButton = ({ className, onClick, buttonStyle, containerStyle, iconClassName }: Props) => {
    const defaultButtonStyle: CSSProperties = {
        borderRadius: "10px",
        border: "1px solid",
        height: "35px"
    };

    const defaultIconStyle: CSSProperties = {
        color: "#323130",
        display: "block"
    };

    return (
        <div className={`${styles.container} ${className ?? ""}`} style={{ paddingLeft: "7px", ...containerStyle }}>
            <PrimaryButton onClick={onClick} style={{ ...defaultButtonStyle, ...buttonStyle }}>
                <Settings24Regular className={iconClassName} style={defaultIconStyle} />
            </PrimaryButton>
        </div>
    );
};
